import Email from './email/Email';
import ImportedId from './imported-id/ImportedId';

export default {
	email: Email,
	imported_id: ImportedId,
};
